import { Injectable } from '@angular/core';
import { ApiResponse } from '@src/app/core/models/api-response.model';
import { ApiWebSubmissionService } from '@src/app/core/services/api-web-submission.service';
import { Observable } from 'rxjs';
import {
  GetEKYCLastRecordResp,
  VerifyInfoAndFaceAndIdCard,
  VerifyInfoAndFaceAndIdCardInfo,
} from '../model/models';

@Injectable({
  providedIn: 'root',
})
export class EKYCService {
  constructor(private apiWebSubmissionService: ApiWebSubmissionService) {}

  VerifyInfoAndFaceAndIdCard(
    params?: VerifyInfoAndFaceAndIdCard
  ): Observable<ApiResponse<VerifyInfoAndFaceAndIdCardInfo>> {
    return this.apiWebSubmissionService.doPost(
      '/EKYC/VerifyInfoAndFaceAndIdCard',
      params
    );
  }

  GetLastEKYCRecord(params: {
    submissionNo: number;
  }): Observable<ApiResponse<GetEKYCLastRecordResp>> {
    return this.apiWebSubmissionService.doGet(
      `/EKYC/GetLastEKYCRecord/${params.submissionNo}`
    );
  }
}
